import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { queryClient } from '@/lib/api/query-client';
import { ThemeProvider } from '@/lib/theme/ThemeProvider';
import { router } from '@/routes';
import { store, persistor } from '@/store';
import { AgentDashboardProvider } from '@/router/context/AgentDashboardContext';
import { BreakProvider } from '@/router/context/BreakContext';

/*
 * Root providers, in order (outer → inner):
 *   1. Redux — the existing app's state layer; every migrated slice
 *      and thunk keeps working with zero adjustments.
 *   2. PersistGate — hydrates Redux from localStorage before the app
 *      renders (matches the existing behaviour).
 *   3. ThemeProvider — obd3-gui's light/dark theme.
 *   4. QueryClient — TanStack Query for new UI code (Redux stays for
 *      the ported logic, TanStack for any new query surfaces).
 *   5. RouterProvider — react-router v6 data router.
 *   6. Toaster — sonner, matches obd3-gui's toast placement.
 */
export function App() {
  return (
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <QueryClientProvider client={queryClient}>
            <AgentDashboardProvider>
              <BreakProvider>
                <RouterProvider router={router} />
              </BreakProvider>
            </AgentDashboardProvider>
            <Toaster position="top-center" richColors closeButton />
          </QueryClientProvider>
        </ThemeProvider>
      </PersistGate>
    </ReduxProvider>
  );
}
